var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCamera = function SvgIconCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4.375 4.375 0 1 0 0 8.75A4.375 4.375 0 0 0 12 8m-2.375 4.375a2.375 2.375 0 1 1 4.75 0 2.375 2.375 0 0 1-4.75 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.75a1 1 0 0 0-.832.445L6.965 5H4.5A2.5 2.5 0 0 0 2 7.5V18a2.5 2.5 0 0 0 2.5 2.5h15A2.5 2.5 0 0 0 22 18V7.5A2.5 2.5 0 0 0 19.5 5h-2.465l-1.203-1.805A1 1 0 0 0 15 2.75zm-.668 3.805L9.535 4.75h4.93l1.203 1.805A1 1 0 0 0 16.5 7h3a.5.5 0 0 1 .5.5V18a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 4 18V7.5a.5.5 0 0 1 .5-.5h3a1 1 0 0 0 .832-.445"
  }))));
};
export default SvgIconCamera;